import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { UserRole, userRoleNameMap } from '../../interfaces/User/UserRole';

interface UserRoleDropdownProps {
  label?: string;
  value?: UserRole;
  onChange: (newRole?: UserRole) => void;
  required?: boolean;
}

export const UserRoleDropdown = (props: UserRoleDropdownProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <FormControl size='small' fullWidth>
        {!!props.label && <InputLabel>{props.label}</InputLabel>}
        <Select
          label={props.label}
          value={props.value ?? '__all__'}
          onChange={(e) =>
            props.onChange(
              e.target.value === '__all__'
                ? undefined
                : (e.target.value as UserRole),
            )
          }
        >
          {!props.required && <MenuItem value='__all__'>Tümü</MenuItem>}
          {Object.entries(userRoleNameMap).map(([key, value]) => (
            <MenuItem key={key} value={key}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
